import '../App.css';
import Headerappprivate from './appPrivate/headerappprivate'
import { Bodyappwaitbuybody} from './/bodyappwaitbuybody'
import { Bodyappfinalbuybody} from './/bodyappfinalbuybody'
import { Footerappprivate } from './appPrivate/footerappprivate'
import withRouter from './/withRouter'
import Axios from 'axios';
import React, {useEffect, useState} from 'react';
import { useParams } from "react-router-dom";
import queryString from "query-string"

function Bodyappwaitbuy(props){
  useParams()

  const [orderProcess, setOrderProcess] = useState(false);
  
useEffect(() => {
  const queryParams = queryString.parse(window.location.search);
  const ws_token = queryParams.token_ws ?? '';
  const status = queryParams.status ?? '';
  const orderBuy = queryParams.order ?? '';
  const flow = queryParams.flow ?? 'ticket';
  const auth = localStorage.getItem('MY_APP_STATE_AUTHCODE');

  if (!auth && !status && !orderBuy && !ws_token) {
    window.location = '/';
    return;
  }

  const valor_ticketSTR = (localStorage.getItem('MY_APP_STATE_PROV_VALOR') ?? '').replace('"', '');
  const usuarioSTR = (localStorage.getItem('MY_APP_STATE_USER') ?? '').replace('"', '');
  const valor_ticket = valor_ticketSTR.replace('"', '');
  const usuario = usuarioSTR.replace('"', '');
  const apiBaseUrl = (process.env.REACT_APP_URLBASE || '').trim().replace(/\/$/, '');
  const voucherUrl = `${apiBaseUrl}/ticketorderTranbank/voucher`;

  const saveReceiptAndFinish = (receipt) => {
    localStorage.setItem('MY_APP_STATE_BOLETA', JSON.stringify(receipt));
    setOrderProcess(true);
  };

  const buildFallbackReceipt = (paymentStatus, message) => ({
    DetailTransaction: {
      status: paymentStatus === 'AUTHORIZED' ? 'AUTHORIZED' : 'FAILED',
      accounting_date: '',
      amount: '',
      authorization_code: '',
      buy_order: orderBuy || '',
      card_detail: {
        card_number: ''
      },
      payment_type_code: '',
      transaction_date: ''
    },
    Message: message,
    MessageCode: '200'
  });

  const getConfirmUrl = () => {
    return flow === 'wallet'
      ? process.env.REACT_APP_URLCONFIRMBILLETERATX
      : process.env.REACT_APP_URLCONFIRMTX;
  };

  const txConfirmar = async () => {
    try {
      const res = await Axios.post(getConfirmUrl(), { ws_token, valor_ticket, usuario });
      saveReceiptAndFinish(res.data);
    } catch (err) {
      console.error("Error confirmación:", {
        status: err?.response?.status,
        data: err?.response?.data,
        msg: err?.message
      });
      saveReceiptAndFinish(err?.response?.data || buildFallbackReceipt('FAILED', 'No fue posible confirmar la transacción.'));
    }
  };

  const loadVoucher = async () => {
    try {
      if (orderBuy) {
        const res = await Axios.get(voucherUrl, {
          params: {
            order_buy: orderBuy
          }
        });
        saveReceiptAndFinish(res.data);
        return;
      }

      const fallbackMessage = {
        AUTHORIZED: 'Orden autorizada.',
        FAILED: 'Orden no autorizada.',
        aborted: 'La transacción fue abortada o no se pudo confirmar.',
        not_found: 'No se encontró la orden asociada a la transacción.',
        exception: 'Ocurrió una excepción al procesar la transacción.'
      };

      saveReceiptAndFinish(
        buildFallbackReceipt(status, fallbackMessage[status] || 'La transacción no pudo ser procesada.')
      );
    } catch (err) {
      console.error("Error obteniendo voucher:", {
        status: err?.response?.status,
        data: err?.response?.data,
        msg: err?.message
      });
      saveReceiptAndFinish(buildFallbackReceipt(status, 'No fue posible obtener el comprobante de la transacción.'));
    }
  };

  if (status) {
    loadVoucher();
    return;
  }

  txConfirmar();
}, []);

  //useEffect(() => {
    
  //  if(window.localStorage.getItem('MY_APP_STATE_AUTHCODE') == '')
  //  {
  //    window.location = ('/')
  //  }
  //  else
  //  {

  //    let ws_tokenstr = JSON.stringify(queryParams.token_ws).replace('"', '')
  //    let valor_ticketstr = window.localStorage.getItem('MY_APP_STATE_PROV_VALOR').replace('"', '')
  //    let usuariostr = window.localStorage.getItem('MY_APP_STATE_USER').replace('"', '')
  //    console.log(ws_tokenstr.replace('"', ''))
  //    //Debe confirmar la transaccion
  //    const data = {       
  //        ws_token: ws_tokenstr.replace('"', ''),
  //        valor_ticket: valor_ticketstr.replace('"', ''),
  //        usuario: usuariostr.replace('"', '') 
  //    };


  //    const txConfirmar = async () => {
  //      try {
  //        console.log("Paso 1. Entra a la funcion Confirmar transaccion")
  //        const res = await Axios.post(process.env.REACT_APP_URLCONFIRMTX, {
  //          ws_token,
  //          valor_ticket,
  //          usuario
  //        });

  //        if (res.status === 200) {
  //          console.log("Paso 2. Respondio con 200 desde el backend");
  //          localStorage.setItem('MY_APP_STATE_BOLETA', JSON.stringify(res.data));
  //          setOrderDetail(res.data);
  //          setOrderProcess(true);
  //        } else {
  //          console.log("Paso 2.1. Respondio con status no 200:", res.status);
  //          setOrderProcess(false);
  //          setOrderDetail("No se ha procesado la orden");
  //        }
  //      } catch (err) {
  //        // Log INSUMIABLE (sin [object Object])
  //        const status = err?.response?.status;
  //        const data   = err?.response?.data;
  //        const msg    = err?.message;
  //        console.error("Paso 2.2 Error confirmación:", { status, data, msg });
  //        setOrderProcess(false);
  //        setOrderDetail("Error confirmando la orden");
  //      }          
  //    };


        //const txConfirm = await Axios.post(process.env.REACT_APP_URLCONFIRMTX, data, {
        //  headers: {
        //      'Access-Control-Allow-Origin' : '*',
        //      'Access-Control-Allow-Methods': 'GET, POST',
        //      'Access-Control-Allow-Headers': 'Content-Type'
        //  }}).then(res => {
        //    statuscall = res
        //    if(statuscall.status == 200)
        //    {
        //        console.log("Paso 2. Respondio con 200 desde el backend")
        //        window.localStorage.setItem('MY_APP_STATE_BOLETA', JSON.stringify(statuscall.data)) 
        //        setOrderDetail(statuscall.data)
        //        setOrderProcess(true)                     
        //    }
        //    else
        //    {
        //        console.log("Paso 2.1. Respondio con error desde backend")
        //        setOrderProcess(false)
        //        setOrderDetail("No se ha procesado la orden")
        //    }
        //  }).catch(err => {
        //        statuscall = err.response
        //        console.log("Paso 2.2 Error en la confirmacion de la transaccion" + statuscall)
        //  });
      //}
  //    txConfirmar();
  //  }
//}, []);  

  return (  
    <div className="App">        
      <Headerappprivate/>
      {!orderProcess ?
        <Bodyappwaitbuybody/>
      : <Bodyappfinalbuybody/>}
      <Footerappprivate/> 
    </div>
  )  
}
export default Bodyappwaitbuy
